import { EdependencyLevel, Model, TLoadDependeciesParams, TLoadParams } from '@df/catalog/model';

export class DependencyLoader {
    private promisesQty: number = 0;
    readonly promise: Promise<void> & { inLoader?: boolean };
    private resolve!: () => void;
    private reject!: (reason?: any) => void;
    private promises = new Set<Promise<any>>();
    private resolved = false;

    private dependenciesInjected = new Map<Model, { verbosity: number; dependencyLevel: EdependencyLevel }>();

    constructor(
        readonly contextType: string,
        readonly contextId: number | string
    ) {
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
        this.promise.inLoader = true;
    }

    add(promise: Promise<any> | undefined | void | null) {
        if (!promise) {
            return;
        }
        if (!this.promises.has(promise)) {
            if (this.resolved) {
                throw new Error('Loader promise already resolved');
            }

            // const promiseLoadError = new Error('Failed to load promise');
            // const timeout = setTimeout(() => {
            //     console.error(promiseLoadError, promise);
            // }, 5000);
            // promise.finally(() => clearTimeout(timeout));
            promise.then(() => {
                this.onPromiseEnd();
                this.promises.delete(promise);
            });
            promise.catch(error => {
                this.onPromiseError(error);
                this.promises.delete(promise);
            });
            this.promises.add(promise);
            this.promisesQty++;
        }
    }

    registerDependencies(model: Model, params: TLoadDependeciesParams) {
        const existing = this.dependenciesInjected.get(model);
        const expected = this.toDependencyState(model, params);
        if (!existing) {
            this.dependenciesInjected.set(model, expected);
        } else {
            if (existing.verbosity < expected.verbosity) {
                existing.verbosity = expected.verbosity;
            }
            if (existing.dependencyLevel < expected.dependencyLevel) {
                existing.dependencyLevel = expected.dependencyLevel;
            }
        }
    }

    hasDependencies(model: Model, params: TLoadParams) {
        const existing = this.dependenciesInjected.get(model);
        if (!existing) {
            return false;
        }
        const expected = this.toDependencyState(model, params);
        return existing.verbosity >= expected.verbosity && existing.dependencyLevel >= expected.dependencyLevel;
    }

    get hasWaitingPromises(): boolean {
        return this.promisesQty > 0;
    }

    private toDependencyState(model: Model, params: TLoadParams) {
        return {
            verbosity: model.verbosity!,
            dependencyLevel: params.dependencyLevel
        };
    }

    private onPromiseEnd() {
        this.promisesQty--;
        if (this.promisesQty === 0) {
            this.resolved = true;
            this.resolve();
        }
    }

    private onPromiseError(err) {
        this.reject(err);
    }
}
